import * as React from 'react';
import FormControlContext from './form_control_context';
var useFormControlContext = () => React.useContext(FormControlContext);
export default useFormControlContext;